/**
 * Reducer for the Fixed Question Delivery New Feature tutorial.
 */

import { fromJS } from 'immutable';

import { SET_TUTORIALS_COMPLETED, RESET_TUTORIALS } from '../actions';

export const FIXED_QUESTION_DELIVERY_TUTORIAL_KEY = 'fixedQuestionDeliveryNewFeature';

const INITIAL_STATE = fromJS({
    completed: false,

    // The FQD tutorial is active by default
    active: true,
    state: null,
});

export function fixedQuestionDeliveryTutorialReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case RESET_TUTORIALS:
            return INITIAL_STATE;

        case SET_TUTORIALS_COMPLETED:
            if (action.tutorialIds.indexOf(FIXED_QUESTION_DELIVERY_TUTORIAL_KEY) !== -1) {
                return fromJS({
                    completed: true,
                    active: false,
                    state: null,
                });
            }
            break;
    }

    return state;
}
